import * as React from "react";
import useDevToolsBase from "./useDevToolsBase";
export default function useReduxDevToolsExtension(ref) {
    var devToolsRef = React.useRef();
    if (devToolsRef.current === undefined && typeof __REDUX_DEVTOOLS_EXTENSION__ !== "undefined") {
        devToolsRef.current = __REDUX_DEVTOOLS_EXTENSION__.connect({
            name: "@react-navigation/devtools"
        });
    }
    var resetRoot = useDevToolsBase(ref, function(result) {
        var devTools = devToolsRef.current;
        if (!devTools) {
            return;
        }
        switch(result.type){
            case "init":
                devTools.init(result.state);
                break;
            case "action":
                devTools.send(result.action, result.state);
                break;
        }
    }).resetRoot;
    React.useEffect(function() {
        var _devToolsRef_current;
        return (_devToolsRef_current = devToolsRef.current) === null || _devToolsRef_current === void 0 ? void 0 : _devToolsRef_current.subscribe(function(message) {
            if (message.type === "DISPATCH" && message.state) {
                var state = JSON.parse(message.state);
                resetRoot(state);
            }
        });
    }, [
        resetRoot
    ]);
}
